import { PEQuestionnaire } from '../../../../../lib/Questionnaires'
import {
  RadioGroupInput,
  CheckboxInput,
  TextInput
} from '../../../../shared/FormBuilder'

function Neck () {
  return (
    <div className='form-section'>
      <div className='row'>
        <div className='col-xs-offset-1 col-xs-4 nh-sub-head'>Normal</div>
        <div className='col-xs-6 nh-sub-head'>Abnormal</div>
      </div>
      <div className='row'>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.neckLAD.name}
            options={[
              {
                label: 'No LAD',
                value: 'No LAD'
              },
              {
                label: 'LAD',
                value: 'LAD'
              }
            ]}
          />
        </div>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.neckROM.name}
            options={[
              {
                label: 'Full ROM',
                value: 'Full ROM'
              },
              {
                label: 'Rigidity',
                value: 'Rigidity'
              }
            ]}
          />
        </div>
        <div className='col-xs-12 margin-top'>
          <CheckboxInput {...PEQuestionnaire.neckOther} />
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12'>
          <TextInput {...PEQuestionnaire.neckOtherText} />
        </div>
      </div>
    </div>
  )
}

export default Neck
